// just a javascript file for now, should use ENV file for this.

export default {
  useAjaxify: true,
};
